import { Auth0ContextInterface, useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect } from 'react';
import { AuthUser } from '@dynamika-shared/types/auth';
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { routesPath } from '@router/routes';
import { useAuthSlice } from '@restore/auth/auth.slice';

export const useAuth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const auth0: Auth0ContextInterface<AuthUser> = useAuth0();
  const [setUser, user] = useAuthSlice((state, actions) => [
    actions.setUser,
    state.data,
  ]);

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  const initialized = auth0.isAuthenticated && !auth0.isLoading;

  const addTokenAndGetMe = useCallback(async () => {
    if (!user) {
      const claims = await auth0.getIdTokenClaims();
      if (claims) {
        sessionStorage.setItem('idToken', claims.__raw);
        sessionStorage.setItem('idTokenExpiration', claims.exp + '');
        if (auth0.user) {
          setUser(auth0.user);
        }
      }
    }
  }, [auth0, user]);

  useEffect(() => {
    if (error || errorDescription) {
      navigate({
        pathname: routesPath.error,
        search: `?${createSearchParams({
          error: error ?? '',
          error_description: errorDescription ?? '',
        })}`,
      });
    }
    if (!auth0.isLoading && !auth0.isAuthenticated) {
      auth0.loginWithRedirect();
    }
    if (auth0.isAuthenticated) {
      addTokenAndGetMe();
    }
  }, [
    addTokenAndGetMe,
    auth0,
    auth0.isAuthenticated,
    auth0.isLoading,
    error,
    errorDescription,
    navigate,
  ]);

  return { user: auth0.user, initialized };
};
